import {searchGreenWayStops}
  from '@/api/green-way/green-way.api.js';

export default class QueryStopsTableConfig {
  constructor({
    stopId = 0,
  }) {
    const config = {
      title: 'Paradas',
      api: (async () => await searchGreenWayStops(stopId)),
      Model: class User {
        constructor(data) {
          Object.keys(data).forEach((k) => (this[k] = data[k]));
        }
      },
      schema: [
        {
          field: 'name',
          sortable: false,
        },
      ],
      actions: {
        header: [],
        item: [],
      },
      messages: {
        loading: 'Cargando resultados',
        empty: 'No hay paradas',
      },
      behaviour: {
        useQuery: false,
      },
    };

    return config;
  }
}
